/**
 * Para birimi sembolünü döndürür
 * @param currency - Para birimi kodu (TRY, USD, EUR)
 * @returns Para birimi sembolü
 */
export const getCurrencySymbol = (currency: string): string => {
  switch(currency) {
    case 'TRY': return '₺';
    case 'USD': return '$';
    case 'EUR': return '€';
    default: return currency;
  }
};

/**
 * KDV veya ÖTV durumunu metne çevirir
 * @param status - Vergi durumu (included, excluded)
 * @returns Vergi durumu metni (Dahil, Hariç)
 */
export const getTaxStatusText = (status: string): string => {
  return status === 'included' ? 'Dahil' : 'Hariç';
};

